import React from "react";
import { BouncedCheck } from "../types";
import { formateDate } from "../hook/ScreenHelper";
import { COLORS } from "../constants";

interface BouncedChecksViewProps {
  data?: BouncedCheck[];
}

const BC_COLUMNS: {
  header: string;
  key: keyof BouncedCheck;
}[] = [
  { header: "BC_PRD", key: "productType" },
  { header: "BC_CRDTR", key: "creditorName" },
  { header: "BC_CHECK_NO", key: "checkNumber" },
  { header: "BC_LOAD_DT", key: "checkDate" },
  { header: "BC_ORIG_AMT", key: "amount" },
  { header: "BC_CUB", key: "unpaidBalance" },
  { header: "BC_STAT", key: "status" },
];

const BC_DATE_COLUMNS: (keyof BouncedCheck)[] = ["checkDate"];


const BouncedChecksView: React.FC<BouncedChecksViewProps> = ({ data = [] }) => {
  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      <p
        className="text-dark m-0"
        style={{
          fontFamily: "Cairo",
          fontWeight: 500,
          fontSize: "20px",
        }}
      >
        Bounced Checks
      </p>

      <table className="table text-center table-border spaced-table">
        {/* HEADER */}
        <thead style={{ background: COLORS.BG_LIGHT }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {BC_COLUMNS.map((col) => (
              <th key={col.header}>{col.header}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {data.map((row, i) => (
            <tr key={row.checkNumber ?? i}>
              {BC_COLUMNS.map((col) => {
                const value = row[col.key];
                const displayValue = BC_DATE_COLUMNS.includes(col.key)
                  ? formateDate(value)
                  : value;

                return (
                  <td key={col.header}>
                    {displayValue ?? "-"}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BouncedChecksView;
